// extracted by mini-css-extract-plugin
export default {"sponContainer":"styles_sponContainer__TY7sP","sponHeader":"styles_sponHeader__Fuvh+"};